export default __webpack_public_path__ + "partials/icon_facebook.hbs";